import { useState } from 'react';
import { IObjektVy } from '../../../../../Types/ObjektVy';
import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { BusinessCollectionCompType } from '../../../../../Types/ObjektVy';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import { makeStyles } from 'tss-react/mui';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import BisattningQuery from './Queries/BisattningQuery.gql';
import {
  BisattningQuery as IBisattningQuery,
  BisattningQuery_node_TEDBOBisattning as IBisattningNode,
  BisattningQueryVariables as IBisattningVariables,
} from './Queries/_QueryTypes/BisattningQuery';
import '../../Rapporter/BJEtiketter/BJEtikett';
import Etikett from '../../Rapporter/BJEtiketter/BJEtikett';
import { useDeleteItem } from '../../../../../Hooks/useDeleteItem';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';

const useStyles = makeStyles()({
  ButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10%',
    width: '80%',
    '&:after': {
      content: '',
      clear: 'both',
      display: 'table',
    },
  },
} as const);

const bisattningModel: IClientBusinessModel =
  clientAvenyModel.BO.BusinessModels.BOBisattning;

const CustomView: BusinessCollectionCompType = props => {
  const { classes } = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const {
    nodeData,
    loading: nodeLoading,
    //refetch: nodeRefetch,
  } = useSelectedDetailQuery<
    IBisattningQuery,
    IBisattningNode,
    IBisattningVariables
  >(BisattningQuery, props.id);
  //console.log(nodeData?._Associations?.SenasteHandelse?._typ);
  const deleteItem = useDeleteItem({
    id: selectedId(props.id),
    item: nodeData,
    collection: bisattningModel,
  });

  return (
    <>
      <BusinessDataForm<IBisattningNode>
        isNew={props.isNew}
        data={nodeData}
        model={bisattningModel}
      >
        <BusinessDataFormContext.Consumer>
          {() => (
            <ObjektVy nodeLoading={nodeLoading} editImplemented>
              <ObjektVySida
                caption="Registrera"
                sidNr={1}
                collectionName={bisattningModel.CollectionName}
              >
                <div>
                  <div className={classes.ButtonContainer}>
                    <EDButton
                      disabled={
                        nodeData?._Associations?.SenasteHandelse?._typ !==
                        'BISATTNINGSHANDELSEREG'
                      }
                      label="Ändra"
                      fullWidth={true}
                    />
                  </div>
                  <div className={classes.ButtonContainer}>
                    <EDButton
                      disabled={
                        nodeData?._Associations?.SenasteHandelse?._typ !==
                        'BISATTNINGSHANDELSEREG'
                      }
                      label="Ta bort"
                      fullWidth={true}
                      onClick={deleteItem}
                    />
                  </div>
                  <div className={classes.ButtonContainer}>
                    <EDButton
                      label="Skriv ut etikett"
                      fullWidth={true}
                      onClick={() => setIsOpen(true)}
                    />
                  </div>
                </div>
              </ObjektVySida>
              <ObjektVySida
                caption="Mer info"
                sidNr={2}
                collectionName={bisattningModel.CollectionName}
              ></ObjektVySida>
            </ObjektVy>
          )}
        </BusinessDataFormContext.Consumer>
      </BusinessDataForm>
      {isOpen && nodeData?.id && (
        <Etikett bjid={nodeData?.id} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export const AktuellaAvlidna: IObjektVy = collectionCompToObjektVy(
  CustomView,
  'AktuellaAvlidna'
);
